export const storeOtp = (otp) => ({
    type: 'STORE_OTP',
    otp
});

export const storePhoneNo = (phoneNo) => ({
    type: 'STORE_PHONE_NO',
    phoneNo
});